import React from 'react';
import { Switch, Route, Redirect, useRouteMatch, useHistory, useLocation } from 'react-router-dom';
import { Container, Row, Col, Button, Navbar } from 'react-bootstrap';
import AdminLogin from './AdminLogin';
import AdminDashboard from './AdminDashboard';
import ConsignerList from './ConsignerList';
import ConsignerDetail from './ConsignerDetail';
import SaleSettings from './SaleSettings';
import ItemList from './ItemList';
import ItemDetail from './ItemDetail';
import AdminNav from './components/AdminNav';
import { getAdminSession, clearAdminSession } from './adminAuth';

// Add pages here as admin features are built. Pages with a label appear in the navigation;
// more specific paths come first so they match before their parent page.
const ADMIN_PAGES = [
  { path: '', label: 'Dashboard', component: AdminDashboard, exact: true },
  { path: '/consigners/:id', component: ConsignerDetail },
  { path: '/consigners', label: 'Consigners', component: ConsignerList },
  { path: '/items/:id', component: ItemDetail },
  { path: '/items', label: 'Items', component: ItemList },
  { path: '/settings', label: 'Sale settings', component: SaleSettings }
];

const NAV_PAGES = ADMIN_PAGES.filter(page => page.label);

function RequireAdmin({ children }) {
  const location = useLocation();
  const session = getAdminSession();
  if (!session) {
    return <Redirect to={{ pathname: '/admin/login', state: { from: location } }} />;
  }
  return children(session);
}

export default function AdminApp() {
  const { path, url } = useRouteMatch();
  const history = useHistory();

  const signOut = () => {
    clearAdminSession();
    history.push(`${url}/login`);
  };

  return (
    <Switch>
      <Route path={`${path}/login`} component={AdminLogin} />
      <Route render={() => (
        <RequireAdmin>
          {session => (
            <Container fluid className="admin-app">
              <Navbar bg="dark" variant="dark" className="mb-3">
                <Navbar.Brand>Cochran's Ski Sale Admin</Navbar.Brand>
                <div className="ml-auto d-flex align-items-center">
                  <Navbar.Text className="mr-3">Signed in as {session.username}</Navbar.Text>
                  <Button variant="outline-light" size="sm" onClick={signOut}>Sign out</Button>
                </div>
              </Navbar>
              <Row>
                <Col md={2}>
                  <AdminNav pages={NAV_PAGES.map(page => ({ to: `${url}${page.path}`, label: page.label, exact: page.exact }))} />
                </Col>
                <Col md={10}>
                  <Switch>
                    {ADMIN_PAGES.map(page => (
                      <Route key={page.path} exact={page.exact} path={`${path}${page.path}`} component={page.component} />
                    ))}
                    <Redirect to={url} />
                  </Switch>
                </Col>
              </Row>
            </Container>
          )}
        </RequireAdmin>
      )} />
    </Switch>
  );
}
